<h1 mat-dialog-title>Commander des crédits</h1>
<div mat-dialog-content>
  <div>
    <p>Commander des crédits payants</p>
    <div class="d-flex flex-column px-2">
      <mat-form-field>
        <mat-label>Pack de crédits</mat-label>
        <mat-select>
          <mat-option value="Pack 100 à 130€">Pack 100 à 130€</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-checkbox>Réappro. auto</mat-checkbox>
    </div>
  </div>

  <mat-divider class="my-3"></mat-divider>

  <div>
    <p>Commander des crédits gratuis</p>
    <div class="d-flex flex-column px-2">
      <mat-form-field>
        <mat-label>Nombre crédits gratuits</mat-label>
        <input matInput placeholder="Ex. 50" value="50" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Commentaire</mat-label>
        <textarea
          matInput
          placeholder="Ex. Offre congrés des notaires"
        ></textarea>
      </mat-form-field>
      <mat-checkbox>Crédits gratuits auto</mat-checkbox>
    </div>
  </div>
</div>
<div mat-dialog-actions class="d-flex justify-content-end mt-3">
  <button mat-raised-button color="primary" class="me-2">Valider</button>
  <button mat-button>Annuler</button>
</div>
